export default __webpack_public_path__ + "static/clouds-5aeac146e5c31ce989abeaf9d8c78659.webp";